import {
  IAggregationCommand,
  ILooseRelationCommand,
  IOrderCommand,
  IQueryCommandOptions,
  IRelationCommand,
  ISearchCommandOptions,
  IWhereCommand,
} from '@llws/dynamic-router-utils';

export const mergeQueryCommands = <T extends IQueryCommandOptions | ISearchCommandOptions>(commands: T[]) => {
  let command: IQueryCommandOptions = {};

  commands.forEach((c) => {
    command = {
      ...(c.alias || command.alias) && { alias: c.alias || command.alias },
      ...(c.limit || command.limit) && { limit: c.limit || command.limit },
      ...(c.page || command.page) && { page: c.page || command.page },
      ...(c.select || command.select) && {
        select: [
          ...command.select ? command.select : [],
          ...c.select ? c.select : [],
        ] as string[],
      },
      ...(c.relations || command.relations) && {
        relations: [
          ...command.relations ? command.relations : [],
          ...c.relations ? c.relations : [],
        ] as IRelationCommand[],
      },
      ...(c.where || command.where) && {
        where: [
          ...command.where ? command.where : [],
          ...c.where ? c.where : [],
        ] as IWhereCommand[],
      },
      ...(c.looseRelations || command.looseRelations) && {
        looseRelations: [
          ...command.looseRelations ? command.looseRelations : [],
          ...c.looseRelations ? c.looseRelations : [],
        ] as ILooseRelationCommand[],
      },
      ...(c.orderBy || command.orderBy) && {
        orderBy: [
          ...command.orderBy ? command.orderBy : [],
          ...c.orderBy ? c.orderBy : [],
        ] as IOrderCommand[],
      },
      ...(c.aggregations || command.aggregations) && {
        aggregations: [
          ...command.aggregations ? command.aggregations : [],
          ...c.aggregations ? c.aggregations : [],
        ] as IAggregationCommand[],
      },
    };
  });

  return command as T;
};
